export const BotServicePath = "https://bot.dentagenix.com";
export const BotWsPath = "wss://bot.dentagenix.com";
